import { loan_application_api } from '@axo/shared/data-access/api';
import { useAPI } from '@axo/shared/data-access/provider';
import { useMutation, useQueryClient } from 'react-query';
import { applicationKeys } from '../../cache-keys/applicationKeys';

export function useDeleteApplicationCar() {
  const client = useQueryClient();
  const api = useAPI();

  return useMutation({
    mutationFn: async ({
      applicationID,
      carID,
    }: {
      applicationID: string;
      carID: string;
    }) => await loan_application_api.deleteCar(api)(applicationID, carID),

    onSettled: (_data, _error, variables) => {
      client.removeQueries(applicationKeys.cars(variables.applicationID));
      client.removeQueries(
        applicationKeys.root({ applicationID: variables.applicationID }),
      );
    },
  });
}
